import { Type } from '@angular/core';

export interface UiLazyRenderedModule {
  readonly renderComponent: Type<unknown>;
}
